import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-turn-off",
  templateUrl: "./med-icon-turn-off.component.html",
})
export class MedIconTurnOffComponent extends SvgMixinComponent {}
